import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import WarningIcon from '@mui/icons-material/Warning';
import ImageIcon from '@mui/icons-material/Image';
import { red } from '@mui/material/colors';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import IconButton from "@mui/material/IconButton";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { useNavigate } from "react-router-dom";
import { Box, Typography, Divider, CardContent, CardMedia, Tab, Tabs, CardActions } from '@mui/material';
import Swal from "sweetalert2";
import { ServerBaseUrlForStaticImages } from "constants";
import CancelIcon from "@mui/icons-material/Cancel";
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import AddVendorModal from './add_vendor'; // Ensure the path is correct
import EditVendorModal from './edit_vendor'; // Ensure the path is correct
import api from "core/interceptors/api";
import { disableBackNavigation } from "core/utils/storage";
import { Delete, ZoomIn } from "@mui/icons-material";
import LogoutButton from "layouts/logout";

function ServiceRegistration() {
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openDeactivateModal, setOpenDeactivateModal] = useState(false);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [Input, setInput] = useState({});
    const [editInput, setEditInput] = useState({});
    const [deleteProductId, setDeleteProductId] = useState(null);
    const [business_type] = useState([
        { id: 1, category_name: "Retail" },
        { id: 2, category_name: "Wholesale" },
        { id: 3, category_name: "Retail & Wholesale" },
    ]);
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectedImages2, setSelectedImages2] = useState([]);
    const [selectedImages3, setSelectedImages3] = useState([]);
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const email = localStorage.getItem("email");
    const [errors, setErrors] = useState({});
    const [feedback, setFeedback] = useState("");
    const [suspendUntil, setSuspendUntil] = useState(null);
    const [suspendReason, setSuspendReason] = useState("");
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalImageOpen, setIsImageModalOpen] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    const [storeEmail, setStoreEmail] = useState('');
    const navigate = useNavigate();
    const [viewImages, setViewImages] = useState({
        vendor_photo: "",
        shop_photo: "",
        sgo_gps_photo: "",
        user_proof_doc: []
    });
    const [businessCategoryOptions, setBusinessCategoryOptions] = useState([]);
    const [fullImage, setFullImage] = useState(null);
    const [globalFilter, setGlobalFilter] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handleGlobalSearchView = () => {
        if (!globalFilter.trim()) return;

        const searchLower = globalFilter.toLowerCase();

        const foundVendor = products.find(vendor =>
            vendor.business_name.toLowerCase().includes(searchLower) ||
            vendor.owner_name.toLowerCase().includes(searchLower) ||
            vendor.email.toLowerCase().includes(searchLower) ||
            (vendor.mobile_number && vendor.mobile_number.toLowerCase().includes(searchLower))
        );

        if (foundVendor) {
            handleViewDetailsImages(foundVendor);
        } else {
            Swal.fire({
                title: "Not Found",
                text: "No matching vendor found!",
                icon: "warning",
                timer: 2000,
                showConfirmButton: false,
            });
        }
    };


    useEffect(() => {
        console.log("User Proof Images:", viewImages?.user_proof_doc);
    }, [viewImages?.user_proof_doc]);

    useEffect(() => {
        const fetchBusinessCategory = async () => {
            try {
                const response = await api.get("/vendor_management/business_category");
                if (response.data.success) {
                    setBusinessCategoryOptions(response.data.business_catgory);
                }
            } catch (error) {
                console.error("Error fetching business categories:", error);
                Swal.fire({
                    title: "Error",
                    text: "Failed to fetch business categories. Please try again.",
                    icon: "error",
                });
            }
        };

        fetchBusinessCategory();
    }, []);

    useEffect(() => {
        disableBackNavigation();
        fetchVendors();
    }, []);

    const fetchVendors = async () => {
        setLoading(true);
        try {
            const response = await api.get("/vendor_register/fetch_approved");
            console.log("Fetched vendors response:", response);

            const vendors = Array.isArray(response.data?.vendors) ? response.data.vendors : [];

            const fetchedVendors = vendors.map(vendor => ({
                ...vendor,
                vendor_photo: vendor.vendor_photo
                    ? `${ServerBaseUrlForStaticImages}/vendor_register/media/${vendor.vendor_photo}`
                    : "",
                shop_photo: vendor.shop_photo
                    ? `${ServerBaseUrlForStaticImages}/vendor_register/media/${vendor.shop_photo}`
                    : "",
                sgo_gps_photo: vendor.sgo_gps_photo
                    ? `${ServerBaseUrlForStaticImages}/vendor_register/media/${vendor.sgo_gps_photo}`
                    : "",
                user_proof_doc: vendor.user_proof_doc && typeof vendor.user_proof_doc === "string"
                    ? vendor.user_proof_doc.split(",").map(doc => `${ServerBaseUrlForStaticImages}/vendor_register/media/${doc.trim()}`)
                    : []
            }));

            console.log("Processed vendors:", fetchedVendors);
            setProducts(fetchedVendors);

            if (fetchedVendors.length > 0) {
                setViewImages(fetchedVendors[0]);
            } else {
                setViewImages({
                    vendor_photo: "",
                    shop_photo: "",
                    sgo_gps_photo: "",
                    user_proof_doc: [],
                });
            }

        } catch (error) {
            console.error("Error fetching vendors:", error);
            Swal.fire({
                title: "Error",
                text: "Failed to load vendors. Please try again later.",
                icon: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    const handleViewDetails = (vendor) => {
        setSelectedVendor(vendor);
        setIsModalOpen(true);
    };

    const handleViewDetailsImages = (vendor) => {
        setViewImages(vendor);
        setStoreEmail(vendor.email);
        setIsImageModalOpen(true);
    };

    const handleImageCloseModal = () => {
        setIsImageModalOpen(false);
        setFullImage(null);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedVendor(null);
    };

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
        fetchVendors();
    };

    const handleImageChange = async (event, imageType, vendorEmail) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("email", vendorEmail);
        formData.append("type", imageType);
        formData.append("file", file);

        try {
            console.log("Uploading image:", formData);
            const response = await api.put('/vendor_register/upload_image', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.status === 1) {
                fetchVendors();
                setIsImageModalOpen(false);
                Swal.fire({
                    title: "Image Updated!",
                    icon: "success",
                    timer: 3000,
                    showConfirmButton: false,
                });
            } else {
                Swal.fire({
                    title: "Error",
                    text: response.data.message || "Image upload failed.",
                    icon: "error",
                });
                console.error("Upload error:", response.data.error);
            }
        } catch (error) {
            console.error("Network error:", error);
            Swal.fire({
                title: "Error",
                text: "An unexpected error occurred during image upload.",
                icon: "error",
            });
        }
    };

    const handleDeleteMedia = async (index, type) => {
        if (type === "image") {
            const filePath = viewImages.user_proof_doc[index];
            const fileName = filePath.substring(filePath.lastIndexOf('/') + 1);

            const formData = new FormData();
            formData.append("email", storeEmail);
            formData.append("field_name", "userProofDoc");
            formData.append("file_name", fileName);

            try {
                const response = await api.post("/vendor_register/remove_vendor_images", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.data.status === 1) {
                    fetchVendors();
                    setIsImageModalOpen(false);
                    Swal.fire({
                        title: "Image Deleted!",
                        icon: "success",
                        timer: 3000,
                        showConfirmButton: false,
                    });
                    setViewImages((prevState) => ({
                        ...prevState,
                        user_proof_doc: prevState.user_proof_doc.filter(
                            (_, i) => i !== index
                        ),
                    }));
                } else {
                    console.error("Error removing image:", response.data.msg);
                    Swal.fire({
                        title: "Error",
                        text: response.data.msg || "Failed to delete image.",
                        icon: "error",
                    });
                }
            } catch (error) {
                console.error("Error deleting image:", error);
                Swal.fire({
                    title: "Error",
                    text: "An unexpected error occurred during image deletion.",
                    icon: "error",
                });
            }
        }
    };

    const handleImageAdd = async (e, key) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        for (let file of files) {
            const formData = new FormData();
            formData.append("email", storeEmail);
            formData.append("field_name", "userProofDoc");
            formData.append("file", file);

            try {
                const response = await api.post("/vendor_register/add_vendor_image", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.data.status === 1) {
                    fetchVendors();
                    setIsImageModalOpen(false);
                    Swal.fire({
                        title: "Image Added!",
                        icon: "success",
                        timer: 3000,
                        showConfirmButton: false,
                    });
                    setViewImages((prevState) => {
                        const existing = Array.isArray(prevState[key]) ? prevState[key] : [];
                        return {
                            ...prevState,
                            [key]: [...existing, `${ServerBaseUrlForStaticImages}/vendor_register/media/${response.data.file_path}`],
                        };
                    });
                } else {
                    console.error("Error adding image:", response.data.msg);
                    Swal.fire({
                        title: "Error",
                        text: response.data.msg || "Failed to add image.",
                        icon: "error",
                    });
                }
            } catch (error) {
                console.error("Error uploading image:", error);
                Swal.fire({
                    title: "Error",
                    text: "An unexpected error occurred during image upload.",
                    icon: "error",
                });
            }
        }
    };

    const handleEditChange = (event) => {
        const { name, value } = event.target;
        setEditInput(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const deleteVendor = async (event) => {
        event.preventDefault();
        try {
            const response = await api.put(`/vendor_register/delete_vendor/${deleteProductId}`);
            if (response.data.status === 1) {
                Swal.fire({
                    title: 'Successfully Deleted Vendor!',
                    icon: 'success',
                    timer: 1500
                });
                fetchVendors();
                handleClose();
            } else {
                Swal.fire({
                    title: 'Error',
                    text: response.data.message || 'Server Problem. Please try again...',
                    icon: 'error',
                });
            }
        } catch (error) {
            console.error("Error deleting vendor:", error);
            Swal.fire({
                title: 'Error',
                text: 'An unexpected error occurred',
                icon: 'error',
            });
        }
    };

    const deactivateVendor = async (event) => {
        event.preventDefault();

        if (!suspendReason.trim()) {
            Swal.fire({
                title: 'Reason Required',
                text: 'Please provide a reason for deactivation.',
                icon: 'warning',
            });
            return;
        }
        if (!suspendUntil) {
            Swal.fire({
                title: 'Date Required',
                text: 'Please select a date until which to suspend the vendor.',
                icon: 'warning',
            });
            return;
        }

        try {
            const response = await api.put(`/vendor_register/suspend_vendor/${deleteProductId}`, {
                suspend_until: suspendUntil.toISOString().split("T")[0],
                suspend_reason: suspendReason,
            });

            if (response.data.success) {
                Swal.fire({
                    title: 'Vendor Deactivated Successfully!',
                    icon: 'success',
                    timer: 1500
                });
                fetchVendors();
                handleClose();
            } else {
                Swal.fire({
                    title: 'Error',
                    text: response.data.message || 'Server Problem. Please try again...',
                    icon: 'error',
                });
            }
        } catch (error) {
            console.error("Error deactivating vendor:", error);
            Swal.fire({
                title: 'Error',
                text: 'An unexpected error occurred',
                icon: 'error',
            });
        }
    };

    const handleClose = () => {
        setInput({});
        setEditInput({});
        setSelectedImages([]);
        setSelectedImages2([]);
        setSelectedImages3([]);
        setOpenEditModal(false);
        setOpenDeleteModal(false);
        setOpenDeactivateModal(false);
        setOpenAddModal(false);
        setFeedback("");
        setSuspendUntil(null);
        setSuspendReason("");
    };

    // Columns definition moved inside the component to resolve the ESLint error
    const columns = [
        {
            Header: "S.No",
            id: "serial",
            Cell: ({ row }) => row.index + 1,
            sortable: false,
        },
        {
            Header: "Business Name",
            accessor: "business_name",
            sortable: true,
        },
        {
            Header: "Owner Name",
            accessor: "owner_name",
            sortable: true,
        },
        {
            Header: "Email",
            accessor: "email",
            sortable: false,
        },
        {
            Header: "Options",
            accessor: "options",
            Cell: ({ row }) => (
                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <IconButton
                        color="success"
                        onClick={() => {
                            setOpenEditModal(true);
                            setEditInput(row.original);
                        }}
                    >
                        <EditIcon />
                    </IconButton>
                    <IconButton
                        color="error"
                        onClick={() => {
                            setDeleteProductId(row.original.email);
                            setOpenDeleteModal(true);
                        }}
                    >
                        <DeleteIcon />
                    </IconButton>
                    <IconButton
                        color="info"
                        onClick={() => handleViewDetails(row.original)}
                    >
                        <VisibilityIcon />
                    </IconButton>
                    <IconButton
                        color="success"
                        onClick={() => handleViewDetailsImages(row.original)}
                    >
                        <ImageIcon />
                    </IconButton>
                    <IconButton
                        color="secondary"
                        onClick={() => {
                            setDeleteProductId(row.original.email);
                            setOpenDeactivateModal(true);
                        }}
                    >
                        <CancelIcon />
                    </IconButton>
                </div>
            )
        }
    ];

    // Filtered data for global search
    const filteredProducts = products.filter(vendor => {
        const searchLower = globalFilter.toLowerCase();
        return (
            vendor.business_name.toLowerCase().includes(searchLower) ||
            vendor.owner_name.toLowerCase().includes(searchLower) ||
            vendor.email.toLowerCase().includes(searchLower) ||
            vendor.business_type.toLowerCase().includes(searchLower) ||
            vendor.business_category.toLowerCase().includes(searchLower) ||
            vendor.mobile_number.toLowerCase().includes(searchLower) ||
            (vendor.keywords && vendor.keywords.toLowerCase().includes(searchLower))
        );
    });

    const data = filteredProducts.map((vendor, index) => ({
        s_no: index + 1,
        shop_id: vendor.shop_id,
        business_name: vendor.business_name,
        business_category: vendor.business_category,
        keywords: vendor.keywords,
        owner_name: vendor.owner_name,
        email: vendor.email,
        password: vendor.password,
        business_type: vendor.business_type,
        mobile_number: vendor.mobile_number,
        account_number: vendor.account_number,
        ifsc_code: vendor.ifsc_code,
        passbook_name: vendor.passbook_name,
        bank_name: vendor.bank_name,
        branch_name: vendor.branch_name,
        aadhar_number: vendor.aadhar_number,
        pan_card_number: vendor.pan_card_number,
        gst: vendor.gst,
        status: vendor.status,
        vendor_photo: vendor.vendor_photo,
        shop_photo: vendor.shop_photo,
        sgo_gps_photo: vendor.sgo_gps_photo,
        user_proof_doc: vendor.user_proof_doc,
    }));

    const paginatedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <DashboardLayout>
            <MDBox display="flex" justifyContent="flex-end" alignItems="center">
                <LogoutButton
                    onLogout={() => {
                        navigate("/login");
                    }}
                />
            </MDBox>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                                <MDTypography variant="h6" color="white">Vendor Details</MDTypography>
                            </MDBox>
                            {/* --- New Section for Add Vendor Button and Search Input --- */}
                            <MDBox
                                display="flex"
                                justifyContent="space-between" /* Distributes space between items */
                                alignItems="center" /* Vertically aligns items in the center */
                                px={3}
                                pt={4} /* Adjust padding as needed */
                                pb={2}
                            >
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={12} sm={6} md={8}> {/* Adjust grid size as needed for the search field */}
                                        <TextField
                                            label="Search Vendors"
                                            variant="outlined"
                                            value={globalFilter}
                                            onChange={(e) => setGlobalFilter(e.target.value)}
                                            InputProps={{
                                                endAdornment: (
                                                    <IconButton
                                                        color="primary"
                                                        onClick={handleGlobalSearchView}
                                                        disabled={!globalFilter}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                ),
                                            }}
                                        />

                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} sx={{ textAlign: { xs: 'left', sm: 'right' } }}> {/* Align button to right on larger screens */}
                                        <MDButton color="success" onClick={() => setOpenAddModal(true)}>Add Vendor</MDButton>
                                    </Grid>
                                </Grid>
                            </MDBox>
                            {/* --- End New Section --- */}
                            <MDBox pt={3}>
                                <DataTable
                                    table={{ columns: columns, rows: paginatedData }}
                                    isSorted={true}
                                    entriesPerPage={{
                                        defaultValue: rowsPerPage,
                                        entries: [5, 10, 15, 20, 25],
                                        onPageSizeChange: (newSize) => {
                                            setRowsPerPage(newSize);
                                            setPage(0);
                                        },
                                    }}
                                    showTotalEntries={true}
                                    canSearch={false}
                                    noEndBorder
                                    pagination={{
                                        variant: "contained",
                                        color: "dark",
                                        page: page,
                                        onPageChange: (e, newPage) => setPage(newPage),
                                        rowsPerPage: rowsPerPage,
                                        onRowsPerPageChange: (e, newRowsPerPage) => {
                                            setRowsPerPage(newRowsPerPage);
                                            setPage(0);
                                        },
                                        count: filteredProducts.length,
                                    }}
                                />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>

            <AddVendorModal open={openAddModal} handleClose={handleCloseAddModal} data={businessCategoryOptions} />
            <EditVendorModal
                open={openEditModal}
                handleClose={handleClose}
                editInput={editInput}
                handleEditChange={handleEditChange}
                data={businessCategoryOptions}
            />

            <Dialog open={openDeleteModal} onClose={handleClose}>
                <MDBox component="form" onSubmit={deleteVendor}>
                    <DialogTitle>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item>
                                <WarningIcon style={{ color: red[700], fontSize: 40 }} />
                            </Grid>
                            <Grid item>
                                <MDTypography variant="h6" component="span">
                                    Confirm Delete
                                </MDTypography>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent>
                        <MDBox p={2} style={{ backgroundColor: red[50], borderLeft: `5px solid ${red[700]}` }}>
                            <MDTypography variant="body1">
                                Are you sure you want to delete this Vendor? This action cannot be undone.
                            </MDTypography>
                        </MDBox>
                    </DialogContent>
                    <DialogActions>
                        <MDButton onClick={handleClose} style={{ color: 'gray' }}>Cancel</MDButton>
                        <MDButton type="submit" color="primary">Delete</MDButton>
                    </DialogActions>
                </MDBox>
            </Dialog>

            <Dialog open={openDeactivateModal} onClose={handleClose}>
                <MDBox component="form" onSubmit={deactivateVendor}>
                    <DialogTitle>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item>
                                <WarningIcon style={{ color: red[700], fontSize: 40 }} />
                            </Grid>
                            <Grid item>
                                <MDTypography variant="h6" component="span">
                                    Confirm Deactivate Vendor
                                </MDTypography>
                            </Grid>
                        </Grid>
                    </DialogTitle>

                    <DialogContent>
                        <MDBox p={2} style={{ backgroundColor: red[50], borderLeft: `5px solid ${red[700]}` }}>
                            <MDTypography variant="body1">
                                Are you sure you want to deactivate this Vendor? This action cannot be undone.
                            </MDTypography>
                        </MDBox>

                        <MDBox mt={2}>
                            <MDTypography variant="body2">Please provide a reason for deactivation:</MDTypography>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                variant="outlined"
                                margin="dense"
                                required
                                value={suspendReason}
                                onChange={(e) => setSuspendReason(e.target.value)}
                                placeholder="Enter your feedback here..."
                            />
                        </MDBox>

                        <MDBox mt={2}>
                            <MDTypography variant="body2">Suspend Until:</MDTypography>
                            <ReactDatePicker
                                selected={suspendUntil}
                                onChange={(date) => setSuspendUntil(date)}
                                minDate={new Date()}
                                dateFormat="yyyy-MM-dd"
                                customInput={<TextField fullWidth margin="dense" required />}
                            />
                        </MDBox>
                    </DialogContent>

                    <DialogActions>
                        <MDButton onClick={handleClose} style={{ color: 'gray' }}>Cancel</MDButton>
                        <MDButton type="submit" color="primary">Deactivate</MDButton>
                    </DialogActions>
                </MDBox>
            </Dialog>

            <Dialog open={isModalOpen} onClose={handleCloseModal} maxWidth="md" fullWidth>
                <DialogTitle sx={{ backgroundColor: '#1976d2', color: 'white !important' }}>
                    <MDTypography variant="h6" color="white">Vendor Details</MDTypography>
                </DialogTitle>

                <DialogContent dividers sx={{ m: 2 }}>
                    {selectedVendor && (
                        <div>
                            <Card sx={{ mt: 2, mb: 2, backgroundColor: '#e3f2fd' }}>
                                <CardContent>
                                    <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', mb: 2 }}>Basic Information</Typography>
                                    <Divider sx={{ my: 1, backgroundColor: '#1976d2' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>Business Name:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.business_name}</Typography>
                                    </Box>
                                    <Divider sx={{ my: 1, backgroundColor: '#1976d2' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>Business Type:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.business_type}</Typography>
                                    </Box>
                                    <Divider sx={{ my: 1, backgroundColor: '#1976d2' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>Business Category:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.business_category}</Typography>
                                    </Box>
                                    <Divider sx={{ my: 1, backgroundColor: '#1976d2' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>Keywords:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.keywords}</Typography>
                                    </Box>
                                    <Divider sx={{ my: 1, backgroundColor: '#1976d2' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>Email:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.email}</Typography>
                                    </Box>
                                    <Divider sx={{ my: 1, backgroundColor: '#1976d2' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>Owner Name:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.owner_name}</Typography>
                                    </Box>
                                    <Divider sx={{ my: 1, backgroundColor: '#1976d2' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>Mobile Number:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.mobile_number}</Typography>
                                    </Box>
                                </CardContent>
                            </Card>

                            <Card sx={{ mb: 2, backgroundColor: '#f3e5f5' }}>
                                <CardContent>
                                    <Typography variant="h6" gutterBottom sx={{ color: '#8e24aa', mb: 2 }}>Bank Details</Typography>
                                    <Divider sx={{ my: 1, backgroundColor: '#8e24aa' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>Account Number:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.account_number}</Typography>
                                    </Box>
                                    <Divider sx={{ my: 1, backgroundColor: '#8e24aa' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>IFSC Code:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.ifsc_code}</Typography>
                                    </Box>
                                    <Divider sx={{ my: 1, backgroundColor: '#8e24aa' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>Bank Name:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.bank_name}</Typography>
                                    </Box>
                                    <Divider sx={{ my: 1, backgroundColor: '#8e24aa' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>Branch Name:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.branch_name}</Typography>
                                    </Box>
                                    <Divider sx={{ my: 1, backgroundColor: '#8e24aa' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>Aadhar Number:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.aadhar_number}</Typography>
                                    </Box>
                                    <Divider sx={{ my: 1, backgroundColor: '#8e24aa' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>PAN Card Number:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.pan_card_number}</Typography>
                                    </Box>
                                    <Divider sx={{ my: 1, backgroundColor: '#8e24aa' }} />
                                    <Box sx={{ mb: 1 }}>
                                        <Typography variant="body3" color="textSecondary"><strong>GST Number:</strong></Typography>
                                        <Typography variant="body2" sx={{ ml: 2 }}>{selectedVendor.gst}</Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </div>
                    )}
                </DialogContent>
                <DialogActions sx={{ backgroundColor: '#f5f5f5' }}>
                    <MDButton onClick={handleCloseModal} color="primary">
                        Close
                    </MDButton>
                </DialogActions>
            </Dialog>

            <Dialog open={isModalImageOpen} onClose={handleImageCloseModal} maxWidth="md" fullWidth>
                <DialogTitle sx={{ fontWeight: "bold", color: "#1976d2", textAlign: "center", fontSize: '16px' }}>
                    Vendor Images
                </DialogTitle>
                <DialogContent dividers>
                    <Tabs value={tabIndex} onChange={(e, newIndex) => setTabIndex(newIndex)} centered>
                        <Tab label="Profile & Shop Images" />
                        <Tab label="Gov ID Proof (Front & Back)" />
                    </Tabs>

                    {tabIndex === 0 && (
                        <Grid container spacing={3} justifyContent="center" mt={2}>
                            {["vendor_photo", "shop_photo", "sgo_gps_photo"].map(
                                (key) =>
                                    viewImages[key] && (
                                        <Grid item xs={12} sm={4} key={key}>
                                            <Card sx={{ boxShadow: 3, borderRadius: 3, overflow: "hidden" }}>
                                                <CardMedia
                                                    component="img"
                                                    height="180"
                                                    image={viewImages[key]}
                                                    alt={key}
                                                    sx={{
                                                        transition: "0.3s",
                                                        cursor: "pointer",
                                                        "&:hover": { transform: "scale(1.05)" },
                                                    }}
                                                    onClick={() => setFullImage(viewImages[key])}
                                                />
                                                <CardContent sx={{ textAlign: "center" }}>
                                                    <Typography fontSize="0.85rem" fontWeight="500" color="#1976d2">
                                                        {key.replace(/_/g, " ").toUpperCase()}
                                                    </Typography>

                                                    <Box mt={1}>
                                                        <MDButton color="warning" size="small" component="label">
                                                            Edit
                                                            <input
                                                                type="file"
                                                                hidden
                                                                onChange={(e) => handleImageChange(e, key, storeEmail)}
                                                            />
                                                        </MDButton>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    )
                            )}
                        </Grid>
                    )}

                    {tabIndex === 1 && (
                        <Grid container spacing={3} justifyContent="center" mt={2} m={2}>
                            {viewImages.user_proof_doc && Array.isArray(viewImages.user_proof_doc) && viewImages.user_proof_doc.length > 0 ? (
                                <Grid container spacing={2}>
                                    {viewImages.user_proof_doc.map((image, index) => (
                                        <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
                                            <Card sx={{ borderRadius: 2, boxShadow: 2, border: "1px solid #ddd", position: "relative", overflow: "hidden" }}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        height: "200px",
                                                        backgroundColor: "#f5f5f5",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => setFullImage(image)}
                                                >
                                                    <CardMedia
                                                        component="img"
                                                        image={image}
                                                        alt={`User Proof ${index}`}
                                                        sx={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                                                    />
                                                </Box>
                                                <CardActions sx={{ display: "flex", justifyContent: "space-between" }}>
                                                    <IconButton onClick={() => setFullImage(image)} color="primary">
                                                        <ZoomIn />
                                                    </IconButton>
                                                    <IconButton onClick={() => handleDeleteMedia(index, "image")} color="error">
                                                        <Delete />
                                                    </IconButton>
                                                </CardActions>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            ) : (
                                <Typography variant="body2" color="textSecondary" textAlign="center" width="100%" mt={2}>
                                    No images available
                                </Typography>
                            )}

                            <Grid item xs={12} sm={4}>
                                <Card
                                    sx={{
                                        boxShadow: 3,
                                        borderRadius: 3,
                                        textAlign: "center",
                                        padding: 2,
                                        cursor: "pointer",
                                    }}
                                >
                                    <MDButton color="primary" component="label">
                                        Add Image
                                        <input
                                            type="file"
                                            hidden
                                            multiple
                                            onChange={(e) => handleImageAdd(e, "user_proof_doc")}
                                        />
                                    </MDButton>
                                </Card>
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center", paddingBottom: 2 }}>
                    <MDButton onClick={handleImageCloseModal} color="primary">
                        Close
                    </MDButton>
                </DialogActions>
            </Dialog>

            <Dialog open={Boolean(fullImage)} onClose={() => setFullImage(null)} maxWidth="lg" fullWidth>
                <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>Full Image</DialogTitle>
                <DialogContent sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src={fullImage} alt="Full" style={{ maxWidth: "100%", maxHeight: "90vh" }} />
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center" }}>
                    <MDButton onClick={() => setFullImage(null)} color="secondary">
                        Close
                    </MDButton>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
}

export default ServiceRegistration;